import { GameMainKeysEnum, GameMainTypesEnum } from '@star/constants';
import { storeToRefs, useTenantStore } from '@star/stores';
import { filter, map } from 'lodash-es';
import { getServerImg, handleServerGameImg } from '@/plugins/game';

const GAME_ID_MAP = {
  [GameMainKeysEnum.LOTTERY]: {
    753: 3,
  },
};

export const transformGameData = (data: any[], type: GameMainTypesEnum) => {
  const { imgDomain } = storeToRefs(useTenantStore());
  switch (type) {
    case GameMainTypesEnum.ELECTRONIC:
    case GameMainTypesEnum.BLOCK_THIRD:
      return map(
        filter(data, item => item.state !== 3),
        item => {
          return {
            ...item,
            playId: item.play_id,
            gtype: item.gtype,
            gameId: item.upper_id || item.upper_play_id,
            gameKey: item.play_name,
            gameName: item.play_cname,
            gameImgUrl: getServerImg(item),
            gameState: item.state,
          };
        }
      );
    default:
      return data;
  }
};

// private String bg_img_url; //首页平台ICON
// private String thumbnail_img_url; //游戏列表ICON
// private String logo1_img_url; //首页热门icon
// private String logo2_img_url; //游戏TAB选中ICON
// private String logo3_img_url; //游戏TAB高亮ICON
// 获取图片地址
export const getGameImageSrc = (
  item: Record<string, any>,
  options: { type: GameMainKeysEnum; imgType?: 1 | 2 | 3; isLocal?: boolean; platform?: string; gameId?: string }
): string => {
  const { type, imgType = 1, isLocal = true, platform, gameId } = options;
  // 1=首页,2=游戏列表
  if (handleServerGameImg(item.bg_img_url) && imgType === 1) {
    return item.bg_img_url;
  } else if (handleServerGameImg(item.thumbnail_img_url) && imgType === 2) {
    return item.thumbnail_img_url;
  }
  // 3是读图片服务器上链接
  if (imgType === 3) {
    const { imgDomain } = storeToRefs(useTenantStore());
    const imgPathTransferMap = {
      lottery: 'caipiao',
      electronic: 'dianzi',
      chess: 'qipai',
      sports: 'tiyu',
      fishing: 'buyu',
      live: 'zhenren',
    };
    return `${imgDomain.value}staticQ/${imgPathTransferMap[type]}/${platform}/cn/game_${gameId}.png`;
  } else {
    const domain = isLocal ? '/images/game/' : 'https://image2.typay2.com/xinyong/game/';
    return `${domain}${type}/${imgType === 1 ? 'm_' : 'g_'}${GAME_ID_MAP[type]?.[item.play_id] || item.play_id}.png`;
  }
};

export default {
  transformGameData,
  getGameImageSrc,
};
